// BlogAndArticleSection.jsx
import React from "react";
import CoinContentList from "./CoinContentList";

export default function BlogAndArticleSection({ userDetails, _apiConnect }) {

  return (
    <section id="features" className="relative">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        {/* Flex: stack on mobile, 50/50 from md+ */}
        <div className="flex flex-col md:flex-row gap-6">
          {/* Left card (50%) */}
          <div className="md:w-1/2">
            <CoinContentList
                    embed
                    title="CMD Blog"
                    jsonField="coin_blog_json"
                    userDetails={userDetails}
                    _apiConnect={_apiConnect}
                />
          </div>

          {/* Right card (50%) */}
          <div className="md:w-1/2">
            <CoinContentList
                    embed
                    title="CMD Articles"
                    jsonField="coin_article_json"
                    userDetails={userDetails}
                    _apiConnect={_apiConnect}
                />
          </div>
        </div>
      </div>
    </section>
  );
}
